import { Diagnostic } from './logDiagnostic';
import { checkRuntimeConfig } from './runtimeConfigDiagnostics';

// Side-effect module: imported first by the app entry so config problems are reported before any
// other module reads window.anovaAppConfig.
const configProblems: Diagnostic[] = checkRuntimeConfig();

/** Non-empty when the app was served without the env it needs; the entry refuses to mount then. */
export function getConfigProblems(): readonly Diagnostic[] {
  return configProblems;
}
